import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie'
import { MSG_ERR, MSG_OK, MSG_WARN } from '../../App';

const Signup = () => {
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [referredByEmail, setReferredByEmail] = useState('');
  const [errors, setErrors] = useState(false);
  const [loading, setLoading] = useState(true);
    const csrftoken = Cookies.get('csrftoken') // Cookies from Django Domain

  useEffect(() => {
    if (localStorage.getItem('token') !== null) {
      window.location.replace('/app/');
    } else {
      setLoading(false);
    }
  }, []);

  const onSubmit = e => {

    //const { displayMsg } = this.props;
    e.preventDefault();

    const user = {
      name: name,
      lastName: lastName,
      email: email,
      password1: password1,
      password2: password2,
      referredByEmail: referredByEmail.trim() || null,
    };


    fetch('/api/users/auth/register/', {
      method: 'POST',
      headers: {
 //       'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
      },
      body: JSON.stringify(user)
    })
      .then(res => res.json())
      .then(data => {
        if (data.key) {
          localStorage.clear();
          localStorage.setItem('token', data.key);
          localStorage.setItem('csrftoken', csrftoken);
          localStorage.setItem('user', data.user);
          localStorage.setItem('firstName', data.firstName);
          localStorage.setItem('colId', data.colId);
          localStorage.setItem('emailConfirmed', data.emailConfirmed);
          window.location.replace('/app/');
        } else {
          setName('');
          setLastName('');
          setEmail('');
          setPassword1('');
          setPassword2('');
          setReferredByEmail('');
          localStorage.clear();
          setErrors(true);
        }
      })
      .catch(err => {
      })
    
  };

  return (
    <div className="card card-body mt-4 mb-4">
      {loading === false && <h1>Signup</h1>}
      {errors === true && <h2>Cannot signup with provided credentials</h2>}
      <form onSubmit={onSubmit}>
      <label htmlFor='name'>Nombre:</label> <br />
        <input
          name='Name'
          type='text'
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />{' '}
        <br />
        <label htmlFor='lastname'>Apellido:</label> <br />
        <input
          name='lastName'
          type='text'
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          required
        />{' '}
        <br />
        <label htmlFor='email'>email:</label> <br />
        <input
          name='email'
          type='email'
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />{' '}
        <br />
        <label htmlFor='referredByEmail'>Referido por (email, opcional):</label> <br />
        <input
          name='referredByEmail'
          type='email'
          value={referredByEmail}
          onChange={e => setReferredByEmail(e.target.value)}
          placeholder='email de quien te invitó'
        />{' '}
        <br />
        <label htmlFor='password1'>Password:</label> <br />
        <input
          name='password1'
          type='password'
          value={password1}
          onChange={e => setPassword1(e.target.value)}
          required
        />{' '}
        <br />
        <label htmlFor='password2'>Confirmar password:</label> <br />
        <input
          name='password2'
          type='password'
          value={password2}
          onChange={e => setPassword2(e.target.value)}
          required
        />{' '}
        <br />
        <button type="submit" className="btn btn-primary m-2">
                            Submit
            </button>
      </form>
    </div>
  );
};

export default Signup;